import { useIntl } from 'react-intl';
import React from 'react';
import { useTitleStore } from 'src/stores/useTitleStore';
import { webhookEndpointsMessages } from 'src/features/webhook-endpoints/utils/messages';
import WebhookEndpointsTable from 'src/features/webhook-endpoints/components/tables/WebhookEndpointsTable';

const WebhookEndpointsLayout = () => {
    const { setTitle, removeTitle } = useTitleStore();
    const { formatMessage } = useIntl();

    React.useEffect(() => {
        setTitle(formatMessage(webhookEndpointsMessages.webhookEndpoints));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return <WebhookEndpointsTable />;
};

export default WebhookEndpointsLayout;
